import { render } from "./Privacy.html?vue&type=template&id=1c1228fc&scoped=true&ts=true&external"
import script from "./Privacy.ts?vue&type=script&lang=ts&external"
export * from "./Privacy.ts?vue&type=script&lang=ts&external"

import "./Privacy.css?vue&type=style&index=0&id=1c1228fc&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1228fc"]])

export default __exports__